import { render, staticRenderFns } from "./BuildingSocietyFormFilesEscalated.vue?vue&type=template&id=728a762e&scoped=true&"
import script from "./BuildingSocietyFormFilesEscalated.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyFormFilesEscalated.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyFormFilesEscalated.vue?vue&type=style&index=0&id=728a762e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a762e",
  null
  
)

export default component.exports